import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { GetMqrParams } from 'redux/services/mqr/types'

import { MqrStatus } from 'models/mqr'

export const useMqrFilters = () => {
  const [query, setQuery] = useQueryParams(
    {
      limit: NumberParam,
      offset: NumberParam,
      search: StringParam,
      status: StringParam,
    },
    {
      removeDefaultsFromUrl: true,
    },
  )

  const params: GetMqrParams = {
    limit: Number(query.limit || 10),
    offset: Number(query.offset || 0),
    search: query.search || '',
    status: (query.status as MqrStatus) || undefined,
  }

  const resetParams = () => {
    setQuery({}, 'replace')
  }

  const setParam = (key: keyof GetMqrParams, value: string) => {
    setQuery({
      [key]: value || undefined,
    })
  }

  const deleteParam = (key: keyof GetMqrParams) => {
    setQuery({
      [key]: undefined,
    })
  }

  return {
    params,
    setParam,
    deleteParam,
    resetParams,
  }
}
